export const initForm = () => {
  const form = document.getElementById("virtualny-dron-form")

  if (form !== null) {
    const paymentRadios = document.querySelectorAll("input[name=payment]")
    const priceEl = document.getElementById("total-price")

    /**
     * Nastavenie ceny objednávky podľa spôsobu id radio inputu platby.
     * @param {string} radioId
     */
    const updatePrice = (radioId) => {
      switch (radioId) {
        case "payment-by-invoice":
          priceEl.innerText = "199 €"
          break
        case "payment-by-card":
          priceEl.innerText = "183,08 €"
          break
        default:
          console.error("Unknown id:", radioId)
      }
    }

    const initiallyCheckedRadio = Array.from(paymentRadios).find(
      (radio) => radio.checked
    )

    if (initiallyCheckedRadio !== undefined) {
      updatePrice(initiallyCheckedRadio.id)
    }

    const handlePaymentRadioChange = (evt) => {
      updatePrice(evt.target.id)
    }

    paymentRadios.forEach((radio) => {
      radio.addEventListener("change", handlePaymentRadioChange)
    })
  }
}
